import http_request from './http_request'
import config from 'config'

function savePoll(
	id,
	studentRecordingAudioEnabled = '0',
	allowPublishWithoutThumbnail = false
) {
	return http_request.put(`${config.api}poll/${id}`)
		.send({
			studentRecordingAudioEnabled,
			allowPublishWithoutThumbnail,
		})
}

function updateSettings(pollId, settings) {
	return http_request.put(config.api + 'poll/' + pollId + '/settings')
		.send({
			...settings,
		})
}

function updateQuestion(value, pollId, iconId, answers) {
	return http_request.put(config.api + 'poll/' + pollId +'/question')
		.send({
			text: value,
			icon_id: iconId,
			answers,
		})
}

function getPoll(id, jwt) {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}
	return http_request.get(config.api + 'poll/' + id)
		.withHeaders(headers)
		.send()
}

export default {
	savePoll,
	getPoll,
	updateQuestion,
	updateSettings,
}
